/**
 * Export `cylinderTypes`.
 */

export const cylinderTypes = {
  lightweight: 'lightweight',
  traditional: 'traditional'
};

/**
 * Export `ImagesGallery` type.
 */

export type ImagesGallery = {
  subtitle?: string | null;
  url: string;
};

/**
 * Export `ListItem` type.
 */

export type ListItem = {
  item: {
    description: string;
    title: string;
  };
  key: string;
};

/**
 * Export `CylinderType` type.
 */

export type CylinderType = keyof typeof cylinderTypes;

/**
 * Export `TechnologyProps` type.
 */

export type TechnologyProps = {
  advantagesList: ListItem[];
  approvalsList?: ListItem[];
  availableInSimulator: boolean;
  awardsImages?: string[];
  bgColor: string;
  bgColorCustomization: string;
  brochureFile?: string;
  customizationImage?: string;
  customizationList?: ListItem[];
  cylinderType: CylinderType;
  description: string;
  featuredImage: string;
  gallery?: string[];
  id: string;
  listDescription: string;
  listImage: string;
  marketId: string;
  realUseCasesGallery?: ImagesGallery[];
  realUseCasesVideoImage?: ImagesGallery[];
  realUseCasesVideoUrl?: string | null;
  relatedTechnologies?: TechnologyProps[];
  slug: string;
  specsImage: string;
  specsList: ListItem[];
  subtitle: string;
  technologyList: ListItem[];
  title: string;
  videoImage?: string;
  videoUrl?: string | null;
};
